import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { taskStatusMeta } from 'features/taskManagement/taskStatusConstants'
import { formatDay } from 'features/actions/workspace/remedialDates'
import { BORDER, LINK, MUTED, PrimaryButton, SecondaryButton, TextButton } from 'features/actions/workspace/ui'

const SuggestionRow = ({ title, to, statusValue, deadline, isRoutine, context, reasons = [], canManage, busy, allowHandles = true, onLink, onDismiss }) => {
  const status = statusValue ? taskStatusMeta(statusValue) : null
  return (
    <Row>
      <Main>
        <Title to={to}>{title || 'Untitled'}</Title>
        <Meta>
          {status && <Status style={{ color: status.color, background: status.bg }}>{status.label}</Status>}
          {deadline && <span>Due {formatDay(deadline)}</span>}
          {isRoutine && <span>Routine compliance task</span>}
          {context && <span>{context}</span>}
        </Meta>
        {reasons.length > 0 && <Why>Why we suggest it: {reasons.join(', ')}</Why>}
      </Main>
      {canManage && (
        <Buttons>
          {allowHandles && !isRoutine && (
            <PrimaryButton type='button' disabled={busy} onClick={() => onLink('handles')}>Link as handled by</PrimaryButton>
          )}
          <SecondaryButton type='button' disabled={busy} onClick={() => onLink('related')}>Link as related</SecondaryButton>
          <MutedTextButton type='button' disabled={busy} onClick={onDismiss}>Not this one</MutedTextButton>
        </Buttons>
      )}
    </Row>
  )
}

export default SuggestionRow

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px dashed ${BORDER};
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1 1 240px;
`

const Title = styled(Link)`
  font-size: 15px;
  font-weight: 700;
  color: ${LINK};
  text-decoration: underline;
  text-underline-offset: 3px;
  overflow-wrap: anywhere;
`

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: center;
  font-size: 14px;
  color: ${MUTED};
`

const Status = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
`

const Why = styled.div`
  font-size: 14px;
  line-height: 1.45;
  color: ${MUTED};
`

const Buttons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`

const MutedTextButton = styled(TextButton)`
  color: ${MUTED};
`
